import { render, staticRenderFns } from "./BlockUserWarningDialog.vue?vue&type=template&id=74aed33f&"
import script from "./BlockUserWarningDialog.vue?vue&type=script&lang=js&"
export * from "./BlockUserWarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports